import * as React from "react";
import { forwardRef } from "react";
const SvgRadioButton = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10, r: 9.5, fill: "#F3F3F3", stroke: "#E3E3E3" }));
const ForwardRef = forwardRef(SvgRadioButton);
export default ForwardRef;
